import React from "react";

const Search = ({ handleSearchTyping, handleSearchClick }) => (
  <div className="searchWrapper">
    <input
      className="searchWrapper__input"
      onChange={handleSearchTyping}
      type="text"
      placeholder="Search All Products"
    />
    <button
      type="button"
      className="button button--secondary searchWrapper__button"
      onClick={handleSearchClick}
    >
      <i className="fas fa-search" />
    </button>
  </div>
);

export default Search;



// WEBPACK FOOTER //
// ./src/modules/Catalog/components/Search.jsx